import React from 'react';

import './sporreskjema-button.scss';

export const sporreskjemaLink =
    'https://forms.office.com/Pages/ResponsePage.aspx?id=QnIPIUAWpEGcTyixMD8s2j4UjPFSJNRPiOgqkUoJYzxUNUZWUko3SDJUMTZXMlozUFQ5MkVZS1RFOS4u';

const SporreskjemaButton = () => (
    <a
        href={sporreskjemaLink}
        id="sporreskjema-link"
        target="_blank"
        className="sporreskjema-button"
        rel="noopener noreferrer"
    >
        Hjelp oss å bli bedre
    </a>
);

export default SporreskjemaButton;
